module.exports = __webpack_public_path__ + "img/head_logo.c53ebd53.png";